import React from "react";
import "../Css/style.css";
function TextAreaForm(Props) {
  const { labelName, value, onchange } = Props;
  return (
    <div className="full-width input-container">
      <label className="mb-2">{labelName}</label>
      <textarea
        value={value}
        onChange={onchange}
        className="full-width borderless text-area"
      ></textarea>
    </div>
  );
}

export default TextAreaForm;
